import React from "react";
import ReactPlayer from "react-player";
import { StyledWrapper } from "@/components/Styled";

const VideoContent = ({ data }: any) => {
  console.log("video data is ", data);

  return (
    <>
      <div className="w-full flex flex-col items-center lg:w-[90%] xl:w-[80%] 2xl:w-[80%] mx-auto px-6 xl:px-2 py-12">
        {data?.title && (
          <h2 className="text-center text-blue-600 font-bold text-2xl md:text-3xl mb-6">
            {data?.title}
          </h2>
        )}

        <div className="relative w-full max-w-[816px] mt-12 sm:mt-6 mx-auto  overflow-hidden shadow-lg">
          <div className="pt-[56.25%] border-2 relative rounded-xl overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full z-20 pointer-events-none rounded-xl shadow-[inset_0_0_50px_rgba(0,0,0,0.9)]" />

            <ReactPlayer
              url={data?.video}
              playing={true}
              className="absolute z-10 top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              loop={true}
              light={data?.thumbnail}
              style={{ borderRadius: "1rem" }}
              config={{
                youtube: {
                  playerVars: {
                    controls: 0,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                    fs: 0,
                    iv_load_policy: 3,
                    cc_load_policy: 0,
                    disablekb: 1,
                    enablejsapi: 1,
                    branding: 0,
                  },
                },
              }}
              onClick={() => {
                // This allows the video to play on one click
                const player = document.querySelector("video");
                if (player) {
                  player.paused ? player.play() : player.pause(); // Toggle play/pause
                }
              }}
            />
          </div>
        </div>

        <div
          className={` w-full mt-[-250px] bg-white pt-5 md:p-8 ${
            data?.description ? "md:border-2 border-blue rounded-3xl md:shadow-lg" : ""
          }`}
        >
          <StyledWrapper>
            <div className="mt-[270px] mx-auto md:grid-cols-2 gap-6 text-homegrey text-lg">
              {data?.description && (
                <p dangerouslySetInnerHTML={{ __html: data?.description }} />
              )}
            </div>
          </StyledWrapper>
        </div>
      </div>
    </>
  );
};

export default VideoContent;
